import { useQuery } from '@tanstack/react-query';

import cmsAxios from 'utils/cmsAxios';

const queryKeyFeature = 'feature';

const fetchFeature = async (key) => {
  const { data: featureResponse } = await cmsAxios.get('/features', {
    params: { filters: { key: { $eq: key } } },
  });

  return featureResponse?.data[0]?.attributes?.disabled;
};

const useGetFeature = (key) => {
  return useQuery({
    queryKey: [queryKeyFeature, key],
    queryFn: () => fetchFeature(key),
  });
};

export { useGetFeature, fetchFeature, queryKeyFeature };
